module.exports = __webpack_public_path__ + "img/Payangel_Business_main_W.1eaf53f5.svg";